// Utility: Shuffle array in place
const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

// Only shuffle the first occurrence of 'aeiou' or 'AEIOU'
export const generateGuestToken = () => {
  const baseToken = "lqusw0sv78yf5fsfdjshfhjgAeIougjfjfjh";
  const regex = /aeiou|AEIOU/i;
  const match = baseToken.match(regex);

  if (!match) return baseToken;

  const start = match.index;
  const length = match[0].length;
  const original = match[0];
  const shuffled = shuffleArray(original.split('')).join('');

  const newToken = baseToken.substring(0, start) + shuffled + baseToken.substring(start + length);
  return newToken;
};
